import { render, staticRenderFns } from "./DrawerLargeScreen.vue?vue&type=template&id=33c47532&"
import script from "./DrawerLargeScreen.vue?vue&type=script&lang=js&"
export * from "./DrawerLargeScreen.vue?vue&type=script&lang=js&"
import style0 from "./DrawerLargeScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})
